export const DB_CONNECTION = "DB_CONNECTION"
export const DB_EXECUTE_QUERY = 'DB_EXECUTE_QUERY'
